import { render, staticRenderFns } from "./task-set-president.vue?vue&type=template&id=25e253a8&scoped=true&"
import script from "./task-set-president.vue?vue&type=script&lang=js&"
export * from "./task-set-president.vue?vue&type=script&lang=js&"
import style0 from "./task-set-president.vue?vue&type=style&index=0&id=25e253a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e253a8",
  null
  
)

export default component.exports